import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'glasses-card',
  templateUrl: './glasses-card.component.html',
  styleUrls: ['./glasses-card.component.css']
})
export class GlassesCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
